/*
 * @providesModule ChatManager
 *
 */

export const ChatStates = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
};

export const FriendStatus = {
  FRIEND: 'friend', //2 users are friends
  REQUEST_SENT: 'friendrequestsend', // user A sent a friend request to user B
  REQUEST_RECEIVED: 'friendrequestreceived', //user A has received a friend request from user B
  NOT_FRIEND: 'not friend', //user A and user B are not friends
};

export const ChatManagerEvents = {
  RECONNECTING: 'reconnecting',
  BLOCKED_WITH_RELOAD: 'blockedWithReload', // emits with a body {shouldReload: boolean}
  NOTIFICATION_COUNT_UPDATE: 'notificationCountUpdate', // emits on either incoming request or unread message count updates, with a body {count: number}
  JOIN_ROOM: 'joinChatRoom', // emits when the SDK joins a room
};

class ChatManager {
  currentState = ChatStates.DISCONNECTED;
  connectWithCompletion(completion: (didConnect: boolean) => void) {
    console.log('ChatManager.connectWithCompletion');
  }
  getQuarantineStatus() {
    console.log('ChatManager.getQuarantineStatus');
    return 'BAN';
  }
  isChatModerationEnabled() {
    console.log('ChatManager.isChatModerationEnabled');
    return false;
  }
  subscribeToEvent(event: string, callback: () => void) {
    console.log('ChatManager.subscribeToEvent');
  }
  isUserAContact() {
    console.log('ChatManager.isUserAContact');
    return false;
  }
  isUserOnline(userId: string) {
    console.log('ChatManager.isUserOnline');
    return false;
  }
  isConnected() {
    console.log('ChatManager.isConnected');
    return false;
  }
  unsubscribeFromEvent(id: string) {
    console.log('ChatManager.unsubscribeFromEvent');
  }
  isBlockedByUser(userId: string) {
    console.log('ChatManager.isBlockedByUser');
    return false;
  }
  denyContactSubscription(userId: string) {
    console.log('ChatManager.denyContactSubscription');
  }
  approveContactSubscription(userId: string) {
    console.log('ChatManager.approveContactSubscription');
  }
  createRoomForUsers(userIds: string[]) {
    console.log('ChatManager.createRoomForUsers');
  }
  sendMessageToRoom(message: string, roomName: string) {
    console.log('ChatManager.sendMessageToRoom');
  }
  subscribeToContact(userId: string) {
    console.log('ChatManager.subscribeToContact');
  }
  getFriendStatus(userId: string) {
    console.log('ChatManager.getFriendStatus');
    return FriendStatus.FRIEND;
  }
  getSubscriptions(callback: (err: string, rooms: string[]) => void) {
    console.log('ChatManager.getSubscriptions');
  }
  joinRoomCreatingIfNeeded(roomName: string) {
    console.log('ChatManager.joinRoomCreatingIfNeeded');
  }
  changeRoom(roomName: string, isNewFriend: boolean, isFriend: boolean, isBlocked: boolean) {
    console.log('ChatManager.changeRoom');
  }
  isUserChatBanned() {
    console.log('ChatManager.isUserChatBanned');
    return false;
  }
  getChatNotificationCount() {
    console.log('ChatManager.getChatNotificationCount');
    return 2;
  }
  hasGameChannel() {
    console.log('ChatManager.hasGameChannel');
    return 2;
  }
}

export default new ChatManager();
